import { ItemPrice } from '@kinet-open-network/client/item-prices/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  FeePayment,
  IFee,
  IServPackageFee,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class Fee extends BaseModel<Fee, 'Fee'> implements IFee {
  static override readonly modelName: AbilitySubjectType = 'Fee';

  name!: string;
  payment!: FeePayment;
  servPackagesFees?: IServPackageFee[];

  @Type(() => ItemPrice)
  prices?: ItemPrice[];

  defaultPrice!: number;

  get activePrice() {
    return this.prices?.find((price) => price.isActive);
  }

  getActivePriceAt(date: Date | number) {
    return this.prices?.find((price) => price.isActiveAt(date));
  }
}
